import React from 'react'
import { Building2, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white pt-16 pb-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand Column */}
          <div className="space-y-6">
            <a href="#" className="flex items-center gap-2">
              <img src="/logo.png" alt="Singh's Best Buy" className="h-12 w-auto object-contain" />
              <span className="font-bricolage font-bold text-2xl tracking-tighter text-white whitespace-nowrap">
                SINGH'S <span className="text-primary-500">BEST BUY</span>
              </span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted partner in finding the perfect luxury home. We curate the finest properties in Gurgaon, ensuring value, quality, and legacy.
            </p>
            {/* Social Icons (Placeholder) */}
            <div className="flex gap-4 pt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-gray-400">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-gray-400">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-gray-400">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-gray-900 flex items-center justify-center hover:bg-primary-500 hover:text-white transition-colors text-gray-400">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-primary-500 pl-3">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/about" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/#testimonials" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="/blogs" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  Blogs
                </a>
              </li>
              <li>
                <a href="/#projects" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  Projects
                </a>
              </li>
            </ul>
          </div>

          {/* Featured Projects */}
          <div>
            <h3 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-primary-500 pl-3">
              Featured Projects
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'Ireo Corridors', slug: 'ireo-corridors' },
                { name: 'Pacific Golf Estate', slug: 'pacific-golf-estate' },
                { name: 'Hero Homes Haridwar', slug: 'hero-homes-haridwar' },
                { name: 'Landmark Skyvue', slug: 'landmark-skyvue' }
              ].map((project) => (
                <li key={project.slug}>
                  <a href={`/property/${project.slug}`} className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                    {project.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-primary-500 pl-3">
              Contact Us
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <span className="text-primary-500 mt-1">📍</span>
                <span className="text-gray-400 text-sm">
                  <strong>Our Offices:</strong><br />
                  • Golf Course Extension Road, Gurgaon<br />
                  • VentureX<br />
                  • Rajouri Garden<br />
                  • Haridwar<br />
                  • Kishan Nagar Chowk, Dehradun
                  <br /><br />
                  <strong>Research Center:</strong><br />
                  • Mayapuri
                </span>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-primary-500">📞</span>
                <a href="tel:+918368225412" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  +91 83682-25412
                </a>
              </li>
              <li className="flex items-center gap-3">
                <span className="text-primary-500">✉️</span>
                <a href="mailto:info@singhsbestbuy.com" className="text-gray-400 hover:text-primary-500 transition-colors text-sm">
                  info@singhsbestbuy.com
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Singh's Best Buy. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-500 hover:text-white text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-white text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
